export default "dist/images/83b2443ab7e7d346766c8f6bc5afc7a7.png";